// Shared INR amount formatter used across dashboard widgets (no currency symbol - callers
// prefix their own ₹, since some UIs need it inline with other text).
export const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '0.00';
    return new Intl.NumberFormat('en-IN', {
        style: 'decimal',
        minimumFractionDigits: 2,
    }).format(amount);
};

// Compact Indian-notation amount (K/L/Cr) for tight spaces like inline bar labels.
export const formatCompactCurrency = (amount) => {
    const value = Number(amount) || 0;
    const abs = Math.abs(value);
    const sign = value < 0 ? '-' : '';
    if (abs >= 1e7) return `${sign}${(abs / 1e7).toFixed(2)}Cr`;
    if (abs >= 1e5) return `${sign}${(abs / 1e5).toFixed(2)}L`;
    if (abs >= 1e3) return `${sign}${(abs / 1e3).toFixed(1)}K`;
    return `${sign}${abs.toFixed(0)}`;
};
